import React from 'react';
import { RouteGroup, SingleRoute } from '@Constants/routes';
import api from '@Services/api';
import Submissions from '../Submissions';
import SubmissionsHub from '../SubmissionsHub';
import BreakdownTab from '../Pages/BreakdownTab';

// Shared between both apps (the instructor app re-exports this module). The
// nav code differs per portal: an admin permission vs an assistant grant —
// `api.defaults.baseURL` is how every shared page tells the two apart.
// The instructor code is comma-OR, exactly like the backend route
// (`instructorCan:submissions,course_content`): a course_content-only
// assistant may use the page, so it must also see the menu entry.
const isAdminPortal = api.defaults.baseURL?.includes('/admin/') === true;
const code = isAdminPortal ? 'v-sub' : 'submissions,course_content';

// Two plain visible subtabs, deliberately NOT isParent/overviewRoute: the
// auto "Overview" chip those produce is hardcoded per layout, while plain
// subroutes render "Queue" / "Breakdown" chips with zero layout changes.
// The hub redirects the bare /dashboard/submissions to the Queue.
export const SubmissionsRoute: RouteGroup = {
	isRouted: true,
	title: 'Submissions',
	route: 'submissions',
	icon: 'fact_check',
	code,
	routes: [
		{
			title: 'Queue',
			route: 'queue',
			code,
			component: <Submissions />,
		} as SingleRoute,
		{
			title: 'Breakdown',
			route: 'breakdown',
			code,
			component: <BreakdownTab />,
		} as SingleRoute,
	],
	component: <SubmissionsHub />,
};
